export function setRequestHealthCard(state, payload) {
  state.requestHealthCard = payload;
}

export function clearRequestHealthCard(state) {
  state.requestHealthCard = undefined;
}

export function setDigitalInsuranceCardInformation(state, payload) {
  state.digitalInsuranceCardInformation = payload;
}

export function clearDigitalInsuranceCardInformation(state) {
  state.digitalInsuranceCardInformation = undefined;
}

export function setShowRequestAcceptedDialog(state, payload) {
  state.showRequestAcceptedDialog = payload;
}

export function clearShowRequestAcceptedDialog(state) {
  state.showRequestAcceptedDialog = false;
}

export function setShowRequestPartiallyAcceptedDialog(state, payload) {
  state.showRequestPartiallyAcceptedDialog = payload;
}

export function clearShowRequestPartiallyAcceptedDialog(state) {
  state.showRequestPartiallyAcceptedDialog = false;
}

export function setShowRequestDeniedDialog(state, payload) {
  state.showRequestDeniedDialog = payload;
}

export function clearShowRequestDeniedDialog(state) {
  state.showRequestDeniedDialog = false;
}
